import {useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {
  deleteGroupData,
  updateAddgroupModal,
  updateAddgroupModalData,
} from "../../../redux/Actions/group.action";

export const useGroupTableActions = (fetchAfterDelete = () => {}) => {
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const dispatch = useDispatch();

  const handleEdit = useCallback(
    (data) => {
      dispatch(updateAddgroupModalData(data));
      dispatch(updateAddgroupModal(true));
      setEditModalStatus(true);
    },
    [dispatch]
  );

  const handleDelete = (id) => {
    setDeleteModalStatus(true);
    setSelectedGroupId(id);
  };

  const deleteGroup = () => {
    const callback = () => {
      setDeleteModalStatus(false);
      setSelectedGroupId("");
      fetchAfterDelete();
    };
    dispatch(deleteGroupData(selectedGroupId, callback));
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "Edit":
          handleEdit(data);
          break;
        case "Delete":
          handleDelete(data.id);
          break;
      }
    },
    [handleEdit]
  );

  return {
    deleteGroup,
    deleteModalStatus,
    editModalStatus,
    handleActionSelection,
    selectedGroupId,
    setDeleteModalStatus,
    setEditModalStatus,
  };
};
